import type { Icon } from '@ctn/ui/types/generic';

export const HOMEPAGE = process.env.REACT_APP_HOME_PAGE;

export const ROUTES = {
	PORTADA: '/',
	LOGIN: '/login',
	ADMINISTRAR: '/administrar',
	MENSAJES: '/mensajes',
	USER: '/administrar/usuario',
	USER_NEW: '/administrar/usuario/nuevo',
	HOME: '/home',
	AVISO_LEGAL: '/aviso-legal',
	ACCESIBILIDAD: '/accesibilidad',
	POLITICA_COOKIES: '/politica-de-cookies',
	NOTIFICATIONS: '/notifications',
	SOLICITUDES: '/solicitudes',
	KEYCLOAK_REDIRECT: '/openid/redirect',
	DATOS_EMISOR: '/datos-emisor',
	LIBRO_SOCIOS: '/libro-socios'
};

export const ROUTES_TRAMITE_RELATIVE = {
	SOLICITUDES: 'solicitudes',
	BORRADORES: 'borradores',
	BORRADORES_NEW: 'borradores/nuevo',
	DETALLE: 'detalle',
	DETALLE_SUJETO: 'solicitudes/:idTramite/sujeto/:idSujeto/:subsanacion/:idTipoSubsanacion',
	DETALLE_SUJETO_SUBSANABLE: 'solicitudes/:idTramite/sujeto/:idSujeto/:idTipoSubsanacion/:idSubsanacion',
	DETALLE_DOCUMENTO: 'solicitudes/:idTramite/documento/:idDocumento',
	DETALLE_DOCUMENTO_SUBSANABLE: 'solicitudes/:idTramite/documento/:idDocumento/:idTipoSubsanacion/:idSubsanacion',
	SUBSANACIONES: 'subsanaciones',
	SUBSANACIONES_PENDIENTES: 'subsanaciones/pendientes',
	SUBSANACIONES_ATENDIDAS: 'subsanaciones/atendidas',
	SUBSANACIONES_DETALLE: 'subsanaciones/:tab/:idTramite/:idTipoSubsanacion/:idSubsanacion',
	SOLICITUDES_DOCUMENTACION: 'solicitudes-documentacion',
	SOLICITUDES_DOCUMENTACION_PENDIENTES: 'solicitudes-documentacion/pendientes',
	SOLICITUDES_DOCUMENTACION_ATENDIDAS: 'solicitudes-documentacion/atendidas',
	SOLICITUDES_DOCUMENTACION_DETALLE: 'solicitudes-documentacion/:tab/detalle',
	TRAMITE_SUCCESS: 'success'
};

export const makeRoutesAbsolute = <T extends Record<string, string>>(
	urlParent: string,
	urlRelatives: T,
): Record<keyof T, string> =>
	Object.entries(urlRelatives).reduce(
		(acc, [key, route]) => ({ ...acc, [key]: `${urlParent}/${route}` }),
		// eslint-disable-next-line @typescript-eslint/prefer-reduce-type-parameter
		{} as Record<keyof T, string>,
	);

export const ROUTES_LABEL = {
	ONC: 'Obra nueva en construcción',
	DON: 'Obra nueva terminada',
	DIVISION_HORIZONTAL: 'División horizontal',
	ACTA_FIN_OBRA: 'Acta final de obra',
	PODERES: 'Poderes',
	USUARIO_NUEVO: 'Añadir usuario',
	USUARIO_EDIT: 'Editar usuario',
	COMPRAVENTA: 'Compraventa',
	LEGITIMACIONES: 'Testimonio legitimación de firmas',
	SOLICITUD: 'Detalle de la solicitud',
	SOLICITUDES: 'Solicitudes',
	SOLICITUDES_BORRADORES: 'Solicitudes y borradores',
	SOLICITUDES_DOCUMENTACION: 'Solicitudes de documentación',
	SOLICITUDES_DOCUMENTACION_DETALLE: 'Detalle de solicitud de documentación',
	DOCUMENTACION_DETALLE: 'Detalle de documento',
	SUJETO_DETALLE: 'Detalle del interviniente',
	SOLICITUD_NUEVA: 'Nueva solicitud de escritura',
	SUBSANACIONES: 'Errores subsanables',
	SUBSANACIONES_DETALLE: 'Detalle del error subsanable',
	ADMINISTRAR: 'Administrar',
	MENSAJES: 'Mis mensajes',
	LIBRO_SOCIOS: 'Libro registro de socios'
};

export const ROUTES_ICON: Record<string, Icon> = {
	DON: 'realstateLine',
	ONC: 'homeConstruction',
	DIVISION_HORIZONTAL: 'realstateMap',
	ACTA_FIN_OBRA: 'documentsHouse',
	PODERES: 'protocol',
	COMPRAVENTA: 'homeHipoteca',
	LEGITIMACIONES: 'verifiedSign',
};

export const ROUTES_RESOURCES = {
	IMAGES: `${HOMEPAGE}/imagenes`,
	DESCARGAS: `${HOMEPAGE}/descargas`,
};
